export default __webpack_public_path__ + "9092a62c8b7df34f91c5c088078de069.svg";